module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"stretches":"Stretches"},"no":{"stretches":"Strekninger"}}')
  delete Component.options._Ctor
}
